
import React from 'react';
import { StandardDatePicker } from '@/components/ui/form-fields';
import { CalendarIcon } from 'lucide-react';

interface DatePickerProps {
  date: string;
  setDate: (date: string) => void;
  label?: string;
  hideLabel?: boolean;
}

export function DatePicker({ date, setDate, label = "Due Date", hideLabel = false }: DatePickerProps) {
  return (
    <StandardDatePicker
      date={date}
      setDate={setDate}
      label={hideLabel ? "" : label}
      icon={hideLabel ? undefined : <CalendarIcon size={14} className="mr-1 text-brandPurple dark:text-purple-400" />}
    />
  );
}
